var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCiberError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 996,
    height: 997,
    viewBox: "0 0 996 997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9477",
    "data-name": "Ret\\xE2ngulo 9477",
    width: 996,
    height: 997,
    transform: "translate(-16826 -21798)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_13",
    "data-name": "Grupo de m\\xE1scara 13",
    transform: "translate(16826 21798)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3438",
    "data-name": "Grupo 3438",
    transform: "translate(-15830 -22721) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8288",
    "data-name": "Caminho 8288",
    d: "M1920,932.184Q1440,69.4,960,427.205T0,932.184",
    transform: "translate(0 64.272)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "33 66",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8289",
    "data-name": "Caminho 8289",
    d: "M1920,908.433Q1440,69.952,960,427.758T0,908.433",
    transform: "translate(0 63.719)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "125 21",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8290",
    "data-name": "Caminho 8290",
    d: "M1920,884.7Q1440,70.528,960,428.334T0,884.7",
    transform: "translate(0 63.143)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "44 5",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8291",
    "data-name": "Caminho 8291",
    d: "M1920,861Q1440,71.128,960,428.934T0,861",
    transform: "translate(0 62.543)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "131 18",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8292",
    "data-name": "Caminho 8292",
    d: "M1920,837.323Q1440,71.754,960,429.56T0,837.323",
    transform: "translate(0 61.917)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "42 90",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8293",
    "data-name": "Caminho 8293",
    d: "M1920,813.673Q1440,72.407,960,430.213T0,813.673",
    transform: "translate(0 61.263)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "75 55",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8294",
    "data-name": "Caminho 8294",
    d: "M1920,790.052Q1440,73.091,960,430.9T0,790.052",
    transform: "translate(0 60.58)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "47 21",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8295",
    "data-name": "Caminho 8295",
    d: "M1920,766.464Q1440,73.805,960,431.611T0,766.464",
    transform: "translate(0 59.866)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "52 56",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8296",
    "data-name": "Caminho 8296",
    d: "M1920,742.908Q1440,74.554,960,432.36T0,742.908",
    transform: "translate(0 59.117)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "92 95",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8297",
    "data-name": "Caminho 8297",
    d: "M1920,719.39Q1440,75.339,960,433.145T0,719.39",
    transform: "translate(0 58.332)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "102 32",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8298",
    "data-name": "Caminho 8298",
    d: "M1920,695.91Q1440,76.163,960,433.969T0,695.91",
    transform: "translate(0 57.508)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "19 11",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8299",
    "data-name": "Caminho 8299",
    d: "M1920,672.472Q1440,77.029,960,434.835T0,672.472",
    transform: "translate(0 56.642)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "117 112",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8300",
    "data-name": "Caminho 8300",
    d: "M1920,649.08Q1440,77.941,960,435.746T0,649.08",
    transform: "translate(0 55.73)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "96 92",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8301",
    "data-name": "Caminho 8301",
    d: "M1920,625.736Q1440,78.9,960,436.707T0,625.736",
    transform: "translate(0 54.77)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "92 124",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8302",
    "data-name": "Caminho 8302",
    d: "M1920,602.446Q1440,79.914,960,437.72T0,602.446",
    transform: "translate(0 53.756)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "39 59",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8303",
    "data-name": "Caminho 8303",
    d: "M1920,579.213Q1440,80.985,960,438.791T0,579.213",
    transform: "translate(0 52.686)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "102 103",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8304",
    "data-name": "Caminho 8304",
    d: "M1920,556.043Q1440,82.119,960,439.925T0,556.043",
    transform: "translate(0 51.552)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "8 30",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8305",
    "data-name": "Caminho 8305",
    d: "M1920,532.941Q1440,83.32,960,441.126T0,532.941",
    transform: "translate(0 50.35)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "96 35",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8306",
    "data-name": "Caminho 8306",
    d: "M1920,509.913Q1440,84.6,960,442.4T0,509.913",
    transform: "translate(0 49.074)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "13 57",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8307",
    "data-name": "Caminho 8307",
    d: "M1920,486.968Q1440,85.955,960,443.761T0,486.968",
    transform: "translate(0 47.716)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "64 118",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8308",
    "data-name": "Caminho 8308",
    d: "M1920,464.112Q1440,87.4,960,445.209T0,464.112",
    transform: "translate(0 46.268)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "93 98",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8309",
    "data-name": "Caminho 8309",
    d: "M1920,441.355q-480-352.405-960,5.4t-960-5.4",
    transform: "translate(0 44.721)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "63 13",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8310",
    "data-name": "Caminho 8310",
    d: "M1920,418.708q-480-328.1-960,29.7T0,418.708",
    transform: "translate(0 43.064)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "28 111",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8311",
    "data-name": "Caminho 8311",
    d: "M1920,396.182q-480-303.8-960,54.008T0,396.182",
    transform: "translate(0 41.286)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "115 37",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8312",
    "data-name": "Caminho 8312",
    d: "M1920,373.793Q1440,94.3,960,452.1T0,373.793",
    transform: "translate(0 39.372)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "57 30",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8313",
    "data-name": "Caminho 8313",
    d: "M1920,351.555Q1440,96.365,960,454.171T0,351.555",
    transform: "translate(0 37.306)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "2 44",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8314",
    "data-name": "Caminho 8314",
    d: "M1920,329.487Q1440,98.6,960,456.407T0,329.487",
    transform: "translate(0 35.069)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "113 86",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8315",
    "data-name": "Caminho 8315",
    d: "M1920,307.613Q1440,101.03,960,458.836T0,307.613",
    transform: "translate(0 32.64)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "102 127",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8316",
    "data-name": "Caminho 8316",
    d: "M1920,285.956Q1440,103.678,960,461.484T0,285.956",
    transform: "translate(0 29.993)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "130 24",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8317",
    "data-name": "Caminho 8317",
    d: "M1920,264.55Q1440,106.575,960,464.381T0,264.55",
    transform: "translate(0 27.096)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "65 68",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8318",
    "data-name": "Caminho 8318",
    d: "M1920,243.43Q1440,109.759,960,467.565T0,243.43",
    transform: "translate(0 23.912)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "104 74",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8319",
    "data-name": "Caminho 8319",
    d: "M1920,222.641Q1440,113.274,960,471.08T0,222.641",
    transform: "translate(0 20.397)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "127 98",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8320",
    "data-name": "Caminho 8320",
    d: "M1920,202.238Q1440,117.174,960,474.98T0,202.238",
    transform: "translate(0 16.496)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "70 40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8321",
    "data-name": "Caminho 8321",
    d: "M1920,182.288q-480-60.759-960,297.046T0,182.288",
    transform: "translate(0 12.143)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "110 118",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8322",
    "data-name": "Caminho 8322",
    d: "M1920,162.874q-480-36.456-960,321.35T0,162.874",
    transform: "translate(0 7.252)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "5 55",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8323",
    "data-name": "Caminho 8323",
    d: "M1920,144.1q-480-12.152-960,345.654T0,144.1",
    transform: "translate(0 1.719)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "42 108",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8324",
    "data-name": "Caminho 8324",
    d: "M1920,126q-480,12.152-960,369.958T0,126",
    transform: "translate(0 -4.481)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "115 112",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8325",
    "data-name": "Caminho 8325",
    d: "M1920,108q-480,36.456-960,394.262T0,108",
    transform: "translate(0 -10.785)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "112 3",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8326",
    "data-name": "Caminho 8326",
    d: "M1920,90q-480,60.759-960,418.565T0,90",
    transform: "translate(0 -17.089)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "118 18",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8327",
    "data-name": "Caminho 8327",
    d: "M1920,72q-480,85.063-960,442.869T0,72",
    transform: "translate(0 -23.392)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "23 46",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8328",
    "data-name": "Caminho 8328",
    d: "M1920,54Q1440,163.367,960,521.173T0,54",
    transform: "translate(0 -29.696)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "103 117",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8329",
    "data-name": "Caminho 8329",
    d: "M1920,36Q1440,169.671,960,527.477T0,36",
    transform: "translate(0 -36)",
    fill: "none",
    stroke: "#00a8ff",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    strokeDasharray: "81 132",
    opacity: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiberError);
export default __webpack_public_path__ + "static/media/ciber_error.a8b0adafdedcecd75ce5d43cd479d6f3.svg";
export { ForwardRef as ReactComponent };